import { Entry, ShimmerBar, Timeline, YearColumn } from "./style.jsx";

export default function TodayBeforeSkeleton({ rows = 6 }) {
  return (
    <Timeline>
      {Array.from({ length: rows }).map((_, i) => (
        <Entry key={i} style={{ "--i": i }}>
          <YearColumn>
            <ShimmerBar style={{ width: 52, height: 22 }} />
            <ShimmerBar style={{ width: 66, height: 10, marginTop: 6 }} />
          </YearColumn>
          <div style={{ display: "flex", gap: 14, padding: "14px 16px" }}>
            <ShimmerBar style={{ width: 72, height: 72, borderRadius: 10 }} />
            <div style={{ flex: 1 }}>
              <ShimmerBar style={{ width: "90%" }} />
              <ShimmerBar style={{ width: "70%", marginTop: 8 }} />
              <ShimmerBar style={{ width: 90, height: 10, marginTop: 12 }} />
            </div>
          </div>
        </Entry>
      ))}
    </Timeline>
  );
}
